export default __webpack_public_path__ + "images/XF.41a8df4.png";